// extracted by mini-css-extract-plugin
export default {"dropdownDiv":"CustomDropdown_dropdownDiv__0EGXZ","dropdown":"CustomDropdown_dropdown__Rs0wU"};